import APIService from '@/services/APIService.js';

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/movimentacoesBlindada/get-all/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/get-by-id/${id}`);
  },
  getByStatus(status) {
    status = status.toUpperCase();
    return APIService.apiCall().get(`/movimentacoesBlindada/get-by-status/${status}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/movimentacoesBlindada/salvar/${postData.id}`, JSON.stringify(postData));
  },
  executar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/duplicar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/movimentacoesBlindada/baixarArquivoResultado/${id}`, { responseType: 'blob', ...config });
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/baixarLogsTecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  },
  getArquivoModelo() {
    return APIService.apiCall().get('movimentacoesBlindada/baixarArquivoModelo/', {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  },
  getArquivoModeloIA() {
    return APIService.apiCall().get('movimentacoesBlindada/baixarArquivoModeloIa/', {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
